import { motion } from "framer-motion";
import { JOURNEY_STEPS } from "@/data/staticContent";

export default function JourneySteps() {
  return (
    <div className="relative" data-testid="journey-steps">
      <div className="absolute left-6 top-4 bottom-4 w-px bg-gradient-to-b from-blue-200 via-purple-200 to-orange-200 hidden md:block" />
      <ol className="space-y-6">
        {JOURNEY_STEPS.map((s, i) => (
          <motion.li
            key={s.title}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.04 }}
            className="relative flex gap-5 items-start"
            data-testid={`journey-step-${i + 1}`}
          >
            <div className="shrink-0 w-12 h-12 rounded-2xl bg-white border-2 border-slate-100 grid place-items-center font-display font-extrabold text-slate-900 shadow-md relative z-10">
              {String(i + 1).padStart(2, "0")}
            </div>
            <div className="pt-1">
              <h3 className="font-display font-bold text-lg text-slate-900 mb-1">{s.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed max-w-2xl">{s.desc}</p>
            </div>
          </motion.li>
        ))}
      </ol>
    </div>
  );
}
